import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useSyncSubscription } from "@/lib/hooks/use-billing";

type SyncButtonProps = {
  label: string;
  errorLabel: string;
};

export function SyncButton({ label, errorLabel }: SyncButtonProps) {
  const syncMutation = useSyncSubscription();

  const handleSync = async () => {
    try {
      await syncMutation.mutateAsync();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : errorLabel);
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={handleSync} loading={syncMutation.isPending}>
      <RefreshCw className="mr-2 h-4 w-4" />
      {label}
    </Button>
  );
}
